export default __webpack_public_path__ + "imgs/4c2dcb2927467ade013c08eaf5573019.jpg";